export { default as ThreeDStockProductsFiltersImageFilterBadge } from './ThreeDStockProductsFiltersImageFilterBadge';
